module.exports = __webpack_public_path__ + "static/headshot-aa3e7b9839f05792daac15f6f6c8f046.jpg";